import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { acceptInvitation } from '@/api/invitations/invitationsApi';
import type {
  AcceptedInvitation,
  AcceptInvitationPayload,
} from '@/api/invitations/invitationsApi.types';

export function useAcceptInvitationMutation(): UseMutationResult<
  AcceptedInvitation,
  Error,
  AcceptInvitationPayload
> {
  return useMutation({
    mutationFn: acceptInvitation,
  });
}
